import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7588d45e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-items-center gap-5" }
const _hoisted_2 = ["id"]

import { ref } from "vue";
import EventsServices from "../../services/EventsServices";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import i18n from "@/core/plugins/i18n";
import UserOrders from "./UserDetailShopComp/UserOrders.vue";
import UserPointsTransaction from "./UserDetailShopComp/UserPointsTransaction.vue";
import UserRewards from "./UserDetailShopComp/UserRewards.vue";
import UserRebate from "./UserDetailShopComp/UserRewardRebate.vue";
import headerMenu from "./HeaderMenu.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'UserDetailShop',
  setup(__props, { expose: __expose }) {

const t = i18n.global.t;
const drawer = ref(false);
const initLoading = ref(false);
const userName = ref("");
const userData = ref<any>({});
const partyId = ref<number>(0);
const show = async (_partyId: number) => {
  drawer.value = true;
  partyId.value = _partyId;
  await fetchUserData(_partyId);
};
const currentTab = ref(1);

const handleTabs = (id: number) => {
  currentTab.value = id;
};

const close = () => {
  drawer.value = false;
  currentTab.value = 1;
  userData.value = {};
  userName.value = "";
  partyId.value = 0;
};

const componentMap = {
  Orders: UserOrders,
  Rebate: UserRebate,
  Rewards: UserRewards,
  Points: UserPointsTransaction,
};

const getComponent = (componentName: string) => {
  return componentMap[componentName];
};
const tabs = ref([
  {
    name: t("title.pointTransaction"),
    component: "Points",
    id: 1,
  },
  {
    name: t("title.shopOrders"),
    component: "Orders",
    id: 2,
  },
  {
    name: t("title.shopRewards"),
    component: "Rewards",
    id: 3,
  },
  {
    name: t("title.rewardRebate"),
    component: "Rebate",
    id: 4,
  },
]);

const fetchUserData = async (_partyId: number) => {
  initLoading.value = true;
  try {
    const res = await EventsServices.queryCustomerList({ partyId: _partyId });
    if (!res.data[0]) {
      MsgPrompt.error(t("error.userNotFound"));
      drawer.value = false;
      return;
    }
    userData.value = res.data[0];
    userName.value = userData.value.nativeName;
  } catch (e) {
    console.log(e);
    MsgPrompt.error(t("error.failedToFetchData"));
    drawer.value = false;
  }
  initLoading.value = false;
};

__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_ShopPoints = _resolveComponent("ShopPoints")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    modelValue: drawer.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((drawer).value = $event)),
    direction: "rtl",
    size: "60%",
    "before-close": close,
    "destroy-on-close": true
  }, {
    header: _withCtx(({ titleId }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", { id: titleId }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("fields.userShopDetail")), 1)
        ], 8, _hoisted_2),
        _createVNode(_component_el_tag, {
          size: "large",
          type: "info"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("fields.name")) + ": ", 1),
            _createElementVNode("span", null, _toDisplayString(userName.value), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tag, { size: "large" }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("fields.totalPoints")) + ": ", 1),
            _createElementVNode("span", null, [
              _createVNode(_component_ShopPoints, {
                points: userData.value.totalPoint
              }, null, 8, ["points"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_tag, {
          size: "large",
          type: "success"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("fields.joinDate")) + ": ", 1),
            _createElementVNode("span", null, [
              _createVNode(_component_TimeShow, {
                type: "reportDate",
                "date-iso-string": userData.value.createdOn
              }, null, 8, ["date-iso-string"])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(headerMenu, {
          tabs: tabs.value,
          onChangeTab: handleTabs
        }, null, 8, ["tabs"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: tab.id
          }, [
            (currentTab.value === tab.id)
              ? (_openBlock(), _createBlock(_resolveDynamicComponent(getComponent(tab.component)), {
                  key: 0,
                  partyId: partyId.value
                }, null, 8, ["partyId"]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})